module.exports = {"654201001":"和平街道","654201002":"杜别克街道","654201003":"新城街道","654201100":"二工镇","654201101":"恰夏镇","654201200":"喀拉哈巴克乡","654201202":"阿西尔达斡尔民族乡","654201203":"阿不都拉乡","654201204":"也门勒乡","654201403":"恰合吉牧场","654201404":"博孜达克农场","654201405":"窝依加依劳牧场","654201406":"地区种牛场","654201503":"兵团农九师一六三团","654201504":"兵团农九师一六四团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654201.json
// module id = 2919
// module chunks = 0